import styled from '@emotion/styled'

export const TableWrapper = styled.div`
  width: 100%;
`
